/* eslint-disable */
import React, { useEffect } from 'react';
import {
    TextField,
    InputAdornment,
    Paper,
    RadioGroup,
    Radio,
    FormControlLabel,
    Autocomplete,
    Box,
    Button,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import UserList from './userList';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import Title from '../title/title';
import Helper from '../../utility/helper';
import { useState, Downgraded, createState } from '@hookstate/core';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import validator from 'validator';
import { useParams } from 'react-router-dom';
import trash from '../../assets/images/trash.svg';
import UserCheckList from './userCheckList';

const listStyle = {
    width: '100%',
    height: '200px',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
        width: '5px',
        height: '5px',
        backgroundColor: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#c1c1c1',
    },
};
const useStyles = makeStyles({
    dialogContentRoot: {
        // maxHeight: 400,
        // overflowY: 'hidden',
        '&::-webkit-scrollbar': {
            width: '5px',
            height: '5px',
            backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
        },
    },
});

const invitationState = createState({
    ccEmail: '',
    bccEmail: '',
    templateID: 0,
    templateName: '',
    attachments: [],
    body: '',
    subject: '',
});
const UserListDialog = (props) => {
    const classes = useStyles();
    // const authState = useAuthState();
    const tags = useState(null);
    const state = useState(invitationState);
    const templates = useState(null);
    const roles = useState(null);
    const userRole = useState(null);
    const selectedUsers = useState([]);
    const selectedTags = useState([]);
    const eventInfo = useState(null);
    const [templateInfo, setTemplateInfo] = React.useState([]);
    const userInfo = useState(null);
    const finalEventParticipants = useState([]);
    const eventData = useState(null);
    const [search, setSearch] = React.useState('');
    const selected = useState([]);
    // const selectedParticipant = useState([]);
    const [ccEmailErr, setCCEmailErr] = React.useState('');
    const [bccEmailErr, setBCCEmailErr] = React.useState('');
    let params = useParams();
    const [inviteParticipants, setInviteParticipants] = React.useState([]);

    // const userTag = useState(null);
    useEffect(() => {
        //const userRoles = Helper.getStorage('userRoles').filter(item => item.status == 1);
        //const userTags = Helper.getStorage('userTags').filter(item => item.status == 1)
        const userEventInfo = Helper.getStorage('eventInfo');
        const guserInfo = Helper.getStorage('userInfo');

        eventInfo.set(userEventInfo);
        userInfo.set(guserInfo);

        if (!props.invitationList) {
            setRolesNTags(userEventInfo.eventID);
        } else {
            state.set({
                ccEmail: '',
                bccEmail: '',
                templateID: 0,
                templateName: '',
                attachments: [],
                body: '',
                subject: '',
            });
        }

        // if (
        //     userRoles &&
        //     userTags &&
        //     (tags.get() == null || roles.get() == null || eventInfo.get() == null || userInfo.get() == null)
        // ) {
        //     // eslint-disable-next-line no-debugger
        //     // debugger;
        //     tags.set(userTags);
        //     roles.set(userRoles);

        // }
    }, []);

    useEffect(() => {
        if (props.eventParticipants && props.eventParticipants.length > 0) {
            let eventParticipants = props.eventParticipants;
            let finalParticipants = eventParticipants.map(
                (item) => item.userID
            );
            finalEventParticipants.set(finalParticipants);
        }
        if (props.users && inviteParticipants.length == 0) {
            setInviteParticipants(props.users);
        }
    }, [props]);

    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        if (
            eventData.get() == null ||
            (eventData.get() && eventData.eventID.value != eventInfo.eventID)
        ) {
            eventData.set(eventInfo);
        }
        getTemplates();
        // getAllParticipants()
    }, []);
    const getTemplates = () => {
        ApiHelper.get(
            APIURLConstants.GET_TEMPLATES(eventData.get().eventID)
        ).then((res) => {
            setTemplateInfo(res.data);
            let data = res.data.rows.filter((el) => {
                return el.status == 1;
            });
            templates.set(data);
        });
    };

    const setRolesNTags = async (eventID) => {
        const rolesdata = ApiHelper.get(APIURLConstants.GET_ROLES(eventID));
        const tagsdata = ApiHelper.get(APIURLConstants.GET_TAGS(eventID));

        await Promise.all([rolesdata, tagsdata]).then((data) => {
            Helper.setStorage('userRoles', data[0].data);
            Helper.setStorage('userTags', data[1].data);
            const rolesd = data[0].data.filter((item) => item.status == 1);
            const tagsd = data[1].data.filter((item) => item.status == 1);
            tags.set(tagsd);
            roles.set(rolesd);
        });
    };
    const handleChangeTemplate = (e) => {
        state.templateID.set(e);
        // commented by naresh as per requirement
        // if (
        //     state.ccEmail.get() === "" ||
        //     state.bccEmail.get() === ""
        // ) {
        let email =
            templateInfo.rows &&
            templateInfo.rows.filter((el) => {
                return el.templateID === e;
            });
        // console.log('email', email);

        state.ccEmail.set(email[0].ccEmailID ? email[0].ccEmailID : '');
        state.bccEmail.set(email[0].bccEmailID ? email[0].bccEmailID : '');
        state.attachments.set(email[0].attachments ? email[0].attachments : '');
        state.body.set(email[0].body ? email[0].body : '');
        state.subject.set(email[0].subject ? email[0].subject : '');
        // }
    };
    const checkSelectedUsers = (value) => {
        console.log('selected : ', value);
        selectedUsers.set(value);
    };
    // function ValidateEmail(event)
    // {
    //     const value = event.target.value.trim();
    //     if (Helper.validEmail(value))
    //     {
    //         setEmailErr('');
    //     } else if (value == '')
    //     {
    //         setEmailErr('Please enter Email');
    //     } else
    //     {
    //         setEmailErr('Please enter valid Email');
    //     }
    // }

    const handleToggle = (value) => {
        const newSelected = selected.attach(Downgraded).get();
        const currentIndex = newSelected.indexOf(value.userID);
        if (currentIndex === -1) {
            newSelected.push(value.userID);
        } else {
            newSelected.splice(currentIndex, 1);
        }

        if (newSelected) {
            selectedParticipant.set(newSelected);
        }
        selected.set(newSelected);
    };
    const ParticipantList = (props) => {
        const [participants, setParticipants] = React.useState([]);

        useEffect(() => {
            setParticipants(props.data);
            if (props.search) {
                let newCollectionTabs = [...props.data];
                let newUserData = newCollectionTabs.filter((user) => {
                    return (
                        user.name
                            .toLowerCase()
                            .indexOf(props.search.toLowerCase().trim()) > -1 ||
                        (user.userType &&
                            user.userType !== null &&
                            user.userType
                                .toLowerCase()
                                .indexOf(props.search.toLowerCase().trim()) >
                            -1) ||
                        (user.userTags &&
                            user.userTags !== null &&
                            user.userTags
                                .toLowerCase()
                                .indexOf(props.search.toLowerCase().trim()) >
                            -1)
                    );
                });
                setParticipants(newUserData);
            }
        }, []);

        return (
            <List sx={listStyle}>
                {participants &&
                    participants.map((item, index) => {
                        const labelId = `checkbox-list-label-${index}`;
                        return (
                            <ListItem key={`user_${index}`} disablePadding>
                                <ListItemButton
                                    onClick={() => handleToggle(item)}
                                    dense>
                                    <ListItemIcon sx={{ height: '28px' }}>
                                        <Checkbox
                                            edge="start"
                                            checked={
                                                selected
                                                    .get()
                                                    .indexOf(item.userID) !== -1
                                            }
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{
                                                'aria-labelledby': labelId,
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        id={labelId}
                                        primary={item.name}
                                    />
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
            </List>
        );
    };

    const setUsers = (values) => {
        selected.set(values);
    }
    const setSearchValue = (value) => {
        setSearch(value);
        if (props.invitationList) {
            let newCollectionTabs = [...props.users];
            let newUserData = newCollectionTabs;
            if (value.trim().length > 0) {
                newUserData = newCollectionTabs.filter((user) => {
                    return (
                        user.name
                            .toLowerCase()
                            .indexOf(value.toLowerCase().trim()) > -1 ||
                        (user.userType &&
                            user.userType !== null &&
                            user.userType
                                .toLowerCase()
                                .indexOf(value.toLowerCase().trim()) >
                            -1) ||
                        (user.userTags &&
                            user.userTags !== null &&
                            user.userTags
                                .toLowerCase()
                                .indexOf(value.toLowerCase().trim()) >
                            -1) ||
                        (user.email && user.email
                            .toLowerCase()
                            .indexOf(value.toLowerCase().trim()) > -1
                        )
                    );
                });
            }
            setInviteParticipants(newUserData);
        }
    }
    const renderDialogContent = () => (
        <>
            <TextField
                size="small"
                fullWidth={true}
                placeholder="Search Individuals or Groups"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
                value={search}
                onChange={(event) => setSearchValue(event.target.value)}
            />
            {props.invitationList ? null : (
                <Paper>
                    <UserList
                        search={search}
                        users={props.users}
                        checkUsers={checkSelectedUsers}
                        skipEventParticipants={finalEventParticipants
                            .attach(Downgraded)
                            .get()}
                    />
                </Paper>
            )}
            {props.invitationList ? (
                <Box>
                    <UserCheckList search={search} data={inviteParticipants} checkUsers={setUsers} />
                    <Box sx={{ marginTop: '10px' }}>
                        <TextField
                            fullWidth
                            sx={{
                                marginRight: 2,
                            }}
                            value={state.ccEmail.get()}
                            size="small"
                            id="outlined-required"
                            label="CC"
                            onChange={(e) => {
                                state.ccEmail.set(e.target.value);
                            }}
                            onBlur={() =>
                                params.userID > 0 ? null : isCCEmailValidate()
                            }
                            error={ccEmailErr.length > 0 ? true : false}
                            helperText={ccEmailErr.length > 0 ? ccEmailErr : ''}
                        />
                    </Box>
                    <Box sx={{ marginTop: '10px' }}>
                        <TextField
                            fullWidth
                            sx={{
                                marginRight: 2,
                            }}
                            value={state.bccEmail.get()}
                            size="small"
                            id="outlined-required"
                            label="BCC"
                            onChange={(e) => {
                                state.bccEmail.set(e.target.value);
                            }}
                            onBlur={() =>
                                params.userID > 0 ? null : isBCCEmailValidate()
                            }
                            error={bccEmailErr.length > 0 ? true : false}
                            helperText={
                                bccEmailErr.length > 0 ? bccEmailErr : ''
                            }
                        />
                    </Box>
                    <Box sx={{ marginTop: '10px' }}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">
                                Template
                            </InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Select Template"
                                onChange={(e) =>
                                    handleChangeTemplate(e.target.value)
                                }>
                                {templates.get() &&
                                    templates.get(Downgraded).map((option) => (
                                        <MenuItem
                                            key={option.templateID}
                                            value={option.templateID}>
                                            {option.templateName}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Box>
                    {/* Start Display Attachment List Here */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            backgroundColor: '#f8f8f8',
                            flex: 1,
                            marginTop: '10px',
                        }}>
                        <Box flex={0.98}>
                            <Typography
                                variant="h4"
                                fontSize={{ xs: '12px', md: '16px' }}
                                fontWeight={500}
                                paddingLeft={1}
                                paddingTop={1}
                                pb={1}>
                                Attachments
                            </Typography>
                        </Box>
                        <label>
                            <Box
                                sx={{
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    alignSelf: 'center',
                                    display: 'flex',
                                }}
                                flex={0.03}
                                id="imageUpload">
                                <AddCircleRoundedIcon
                                    sx={{ color: '#008000' }}
                                />
                                <input
                                    type="file"
                                    id="files"
                                    multiple={true}
                                    hidden
                                    onChange={handleFileChange}
                                />
                            </Box>
                        </label>
                    </Box>

                    {state.attachments.attach(Downgraded).get() &&
                        state.attachments.attach(Downgraded).get().length > 0 ? (
                        <>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    flex: 1,
                                    marginTop: 1,
                                    backgroundColor: '#f8f8f8',
                                }}>
                                <Box
                                    flex={0.65}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'start',
                                        lineHeight: '0',
                                    }}>
                                    <Typography
                                        variant="h2"
                                        fontSize={12}
                                        fontWeight={500}
                                        paddingLeft={1}
                                        paddingTop={1}
                                        sx={{ paddingLeft: 5 }}
                                        color={'primary'}
                                        pb={1}>
                                        File Name
                                    </Typography>
                                </Box>
                                <Box
                                    flex={0.3}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'start',
                                        lineHeight: '0',
                                    }}>
                                    <Typography
                                        variant="h2"
                                        fontSize={12}
                                        fontWeight={500}
                                        paddingLeft={1}
                                        paddingTop={1}
                                        sx={{ paddingLeft: 5 }}
                                        color={'primary'}
                                        pb={1}>
                                        Created Date
                                    </Typography>
                                </Box>
                            </Box>
                            {state.attachments.attach(Downgraded).get() &&
                                state.attachments
                                    .attach(Downgraded)
                                    .get()
                                    .map((file, idx) => {

                                        let extension = file.fileName.substring(file.fileName.lastIndexOf('.') + 1);
                                        let fileName = file.fileName.substring(0, file.fileName.lastIndexOf('.'));
                                        return (
                                            <Box
                                                key={idx}
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    flex: 1,
                                                    marginTop: 1,
                                                    backgroundColor: '#f8f8f8',
                                                }}>
                                                <Box
                                                    flex={0.65}
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'start',
                                                        lineHeight: '0',
                                                    }}>
                                                    <Typography
                                                        variant="h2"
                                                        fontSize={14}
                                                        fontWeight={400}
                                                        paddingLeft={1}
                                                        paddingTop={1}
                                                        sx={{ paddingLeft: 5 }}
                                                        pb={1}>
                                                        {Helper.removeLastChars(fileName, 14) + '.' + extension}
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    flex={0.3}
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'start',
                                                        lineHeight: '0',
                                                    }}>
                                                    <Typography
                                                        variant="h2"
                                                        fontSize={14}
                                                        fontWeight={400}
                                                        paddingLeft={1}
                                                        paddingTop={1}
                                                        sx={{ paddingLeft: 5 }}
                                                        pb={1}>
                                                        {`${Helper.FormatYearDate(
                                                            new Date()
                                                        )} ${Helper.FormatTime24(
                                                            new Date()
                                                        )}`}
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        flex: 0.05,
                                                    }}>
                                                    <Box
                                                        component="img"
                                                        className={
                                                            classes.sedanBlack
                                                        }
                                                        alt="logo."
                                                        src={trash}
                                                        onClick={() =>
                                                            handleRemove(idx)
                                                        }
                                                    />
                                                </Box>
                                            </Box>
                                        );
                                    })}{' '}
                        </>
                    ) : null}
                    {/* End Display Attachment List Here */}
                </Box>
            ) : (
                <>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={15}
                        fontWeight={700}
                        fontFamily={'Lato'}
                        noWrap
                        fontStyle="normal"
                        color='primary'
                        component="div"
                        sx={{
                            ml: 0,
                            pt: 2,
                            pb: 1,
                        }}
                    >Select Role</Typography>
                    {/* <Title
                        title="Select Role"
                        sx={{
                            ml: 0,
                            pt: 2,
                            pb: 1,
                        }}
                        px={0}
                    /> */}
                    {roles.get() && roles.get().length > 0 ? (
                        <RadioGroup
                            row
                            aria-label="tripType"
                            name="userRole"
                            value={userRole.get()}
                            onChange={(event) =>
                                userRole.set(event.target.value)
                            }>
                            {roles
                                .attach(Downgraded)
                                .get()
                                .map((item, index) => {
                                    return (
                                        <FormControlLabel
                                            key={`roles_${index}`}
                                            value={item.roleID}
                                            control={
                                                <Radio
                                                    color="primary"
                                                    size="small"
                                                />
                                            }
                                            label={item.roleName}
                                        />
                                    );
                                })}
                        </RadioGroup>
                    ) : null}
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={15}
                        fontWeight={700}
                        fontFamily={'Lato'}
                        noWrap
                        fontStyle="normal"
                        color='primary'
                        component="div"
                        sx={{
                            ml: 0,
                            pt: 1,
                            pb: 1,
                        }}
                    >Add Tags</Typography>
                    {/* <Title
                        title="Add Tags"
                        sx={{
                            ml: 0,
                            pt: 1,
                            pb: 1,
                        }}
                        px={0}
                    /> */}
                    {tags.get() ? (
                        <Autocomplete
                            multiple
                            id="size-small-standard-multi"
                            size="small"
                            options={tags.attach(Downgraded).get()}
                            getOptionLabel={(option) => option.tagName}
                            value={selectedTags.attach(Downgraded).get()}
                            onChange={(event, newValue) => {
                                selectedTags.set(newValue);
                            }}
                            // defaultValue={[top100Films[1]]}
                            renderInput={(params) => (
                                <TextField {...params} placeholder="Tags" />
                            )}
                        />
                    ) : null}
                </>
            )}
        </>
    );
    const renderDialogActions = () => (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            <ButtonContainer
                showLoading={props.showLoading}
                loading={props.showLoading}
                handleClick={
                    props.invitationList ? handleAddInvitationList : handleClick
                }
                handleCancel={props.handleClose}
                buttonText={'Create'}
            />
            {props.invitationList ? null : (
                <Button
                    variant="outlined"
                    sx={{ marginTop: '16px' }}
                    onClick={handleCreateAndPublished}>

                    {props.showLoading ? (<> <CircularProgress /> {' Create & Published'} </>) : ' Create & Published'}
                </Button>
            )}
        </Box>
    );

    const handleFileChange = async (e) => {
        let BlobFiles = [];
        var targetFiles = e.target.files;
        const files = state.attachments.get()
            ? [...state.attachments.attach(Downgraded).get()]
            : [];
        Object.values(targetFiles).forEach((item) => {
            const file = item;
            let blob = file.slice(0, file.size, file.type);
            let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
            let fileName = file.name.substring(0, file.name.lastIndexOf('.'));
            let newFileName =
                fileName + '_' + new Date().getTime() + '.' + extension;
            const newFile = new File([blob], newFileName, {
                type: file.type,
            });
            BlobFiles.push(newFile);
            files.push({
                fileName: newFileName,
                createdDate:
                    Helper.FormatYearDate(new Date()) +
                    ' ' +
                    Helper.FormatTime24(new Date()),
                createdBy: userInfo.attach(Downgraded).get().userID,
                isAvailableAtBlob: false,
                file: newFile,
            });
        });
        state.attachments.set(files);
    };

    const handleRemove = (index) => {
        const values = [...state.attach(Downgraded).get().attachments];
        values.splice(index, 1);
        state.attachments.set(values);
        const dt = new DataTransfer();
        const input = document.getElementById('files');
        const { files } = input;

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (index !== i) dt.items.add(file); // here you exclude the file. thus removing it.
        }
        input.files = dt.files; // Assign the updates list
    };
    const saveAppNotification = (usersIds) => {
        const AppNotificationData = {
            userIDs: usersIds.toString(),
            appNotificationTypeID: 4,
            eventID: eventInfo.attach(Downgraded).get().eventID,
            moduleID: 9,
            recordRefID: eventInfo.attach(Downgraded).get().eventID,
            requestStatus: 2,
            status: 0,
            createdBy: userInfo.attach(Downgraded).get().userID,
        };
        ApiHelper.post(
            APIURLConstants.SAVE_APP_NOTIFICATION,
            AppNotificationData
        )
            .then((res) => {
                console.log('res1', res);
                usersIds.map((user) => {
                    ApiHelper.get(
                        APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                            user,
                            eventData.get().eventID,
                            eventData.get().eventName,
                            'Participant',
                            'Published'
                        )
                    ).then((res) => {
                        console.log(res);
                    });
                })

            })
            .catch((err) => {
                console.log('err', err);
            });
    };
    const handleAddInvitationList = () => {
        (!props.enableLoader) && props.setShowLoading(true);
        if (selected.get().length == 0) {
            (!props.enableLoader) && props.setShowLoading(false);
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants',
            });
        } else if (state.templateID.get() === 0) {
            (!props.enableLoader) && props.setShowLoading(false);
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Template',
            });
        } else {
            let requestObj = {
                invitations: [],
                attachments: [],
            };

            const ccValid = isCCEmailValidate();
            const bccValid = isBCCEmailValidate();
            if (
                ccEmailErr.length > 0 ||
                bccEmailErr.length > 0 ||
                ccValid == false ||
                bccValid == false
            ) {
                return false;
            }
            const tempAttachment = [];
            state.attachments.attach(Downgraded).get() &&
                state.attachments
                    .attach(Downgraded)
                    .get()
                    .forEach((file) => {
                        tempAttachment.push({
                            InvitationID: 0,
                            TemplateID: 0,
                            FileName: file.fileName,
                            CreatedBy: userInfo.attach(Downgraded).get().userID,
                        });
                    });

            const selectedParticipants = selected.attach(Downgraded).get();
            selectedParticipants.map((item) => {
                requestObj.invitations.push({
                    EventID: eventInfo.attach(Downgraded).get().eventID,
                    TemplateID: state.templateID.get(),
                    UserID: item,
                    //Body: state.body.get(),
                    Subject: state.subject.get(),
                    Status: 0,
                    CCEmailID:
                        state.ccEmail.get() == null ? '' : state.ccEmail.get(),
                    BCCEmailID:
                        state.bccEmail.get() == null
                            ? ''
                            : state.bccEmail.get(),
                    SentDateTime: Helper.FormatDateWithTime(new Date()),
                    CreatedBy: userInfo.attach(Downgraded).get().userID,
                    ModifiedBy: userInfo.attach(Downgraded).get().userID,
                    // attachments: tempAttachment,
                });
            });
            requestObj.attachments = tempAttachment;

            let templateData = new FormData();
            templateData.append('templateBody', state.body.get() ? encodeURIComponent(state.body.get()) : '');
            templateData.append(
                'Invitations',
                JSON.stringify(requestObj.invitations)
            );
            templateData.append(
                'Attachments',
                JSON.stringify(requestObj.attachments)
            );
            state.attachments.attach(Downgraded).get() &&
                state.attachments
                    .attach(Downgraded)
                    .get()
                    .filter((x) => x.isAvailableAtBlob == false)
                    .forEach(async (file) => {
                        if (file.file) {
                            let newFile = file.file;
                            templateData.append('UploadAttachments', newFile);
                        }
                    });

            const allData = props.invitationInfo;
            const allDataExcludeArchive = allData ? allData.filter(i => i.status !== 2) : [];
            const userData = requestObj.invitations;
            // const filterdData =
            //     allDataExcludeArchive != null
            //         ? allDataExcludeArchive.filter(
            //             (item) => item.userID === userData[0].UserID
            //         )
            //         : [];
            let dataExist = false;
            userData.forEach(data => {
                dataExist = allDataExcludeArchive.some(i => i.userID === data.UserID
                    && i.templateID === data.TemplateID);
                if (dataExist) {
                    return;
                }
            })

            // if (
            //     filterdData.length > 0 &&
            //     filterdData[0].userID === userData[0].UserID &&
            //     userData[0].TemplateID === filterdData[0].templateID
            // ) 
            if (dataExist) {
                (!props.enableLoader) && props.setShowLoading(false);
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'This Template already assigned to selected user',
                });
            } else {
                ApiHelper.post(
                    APIURLConstants.POST_ADD_INVITATION,
                    templateData
                )
                    .then((res) => {
                        if (res.data > 0) {
                            (!props.enableLoader) && props.setShowLoading(false);
                            props.setSnackBarProps({
                                ...props.snackBarProps,
                                openSnack: true,
                                variant: 'success',
                                message: 'Invitations created successfully',
                            });
                            props.getParticipants();
                            props.handleClose();
                        }
                    })
                    .catch((error) => {
                        (!props.enableLoader) && props.setShowLoading(false);
                        let message = '';
                        if (error.response && error.response.status === 401) {
                            message = 'Access denied';
                        } else {
                            message = 'Error while adding invitation';
                        }
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: message,
                        });
                        // props.handleClose();
                        // props.getParticipants();
                    });
            }
        }
    };
    // const welcomeEmail = (userIds, eventID, modifiedBy) => {
    //     let form = new FormData();
    //     form.append("EventID", eventID);
    //     form.append("UserIDs", userIds);
    //     form.append('ModifyBy', modifiedBy)
    //     ApiHelper.post(APIURLConstants.POST_WELCOME_EMAIL, form)
    //     .then((res) => {
    //         console.log("res",res);
    //     })
    // }
    const handleClick = () => {
        (!props.enableLoader) && props.setShowLoading(true);
        if (selectedUsers.get().length == 0) {
            (!props.enableLoader) && props.setShowLoading(false);
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants',
            });
        } else {
            const setUserTags = selectedTags.attach(Downgraded).get();
            const setUserTagsList =
                setUserTags.length > 0
                    ? setUserTags.map((tag) => tag.tagID).join(',')
                    : '';

            let requestObj = {
                participants: [],
                userTags: setUserTagsList,
            };
            let users = selectedUsers.attach(Downgraded).get();
            users.forEach((item) => {
                requestObj.participants.push({
                    eventUsersID: 0,
                    eventID: eventInfo.attach(Downgraded).get().eventID,
                    userID: item,
                    roleID: parseInt(userRole.get() ? userRole.get() : 0),
                    createdBy: userInfo.attach(Downgraded).get().userID,
                });
            });
            ApiHelper.post(APIURLConstants.POST_EVENT_PARTICIPANTS, requestObj)
                .then((res) => {
                    if (res.data > 0) {
                        (!props.enableLoader) && props.setShowLoading(false);
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Participants added successfully',
                        });
                        // if (eventData.get().readonlyOrHide === 0) {
                        //     saveAppNotification(users);
                        // }
                        // welcomeEmail(users.toString(),eventInfo.attach(Downgraded).get().eventID,userInfo.attach(Downgraded).get().userID)
                        props.handleClose();
                        props.getParticipants();
                        props.getAllParticipants();
                    }
                })
                .catch((error) => {
                    (!props.enableLoader) && props.setShowLoading(false);
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Error while adding participant';
                    }
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                    // props.handleClose();
                    // props.getParticipants();
                });
            //props.handleClose();
        }
    };

    const isCCEmailValidate = () => {
        let flag = true;
        const email =
            state.ccEmail.get() != null ? state.ccEmail.get().trim() : '';
        let selectedEmails = [];
        if (email) {
            selectedEmails = email.split(',');
            selectedEmails.map((item) => {
                flag = item != '' ? validateEmail(item) : true;
                flag
                    ? setCCEmailErr('')
                    : setCCEmailErr('Please enter valid CC Email');
            });
        } else setCCEmailErr('');
        return flag;
    };
    const isBCCEmailValidate = () => {
        let flag = true;
        const email =
            state.bccEmail.get() != null ? state.bccEmail.get().trim() : '';
        let selectedEmails = [];
        if (email) {
            selectedEmails = email.split(',');
            selectedEmails.map((item) => {
                flag = item != '' ? validateEmail(item) : true;
                flag
                    ? setBCCEmailErr('')
                    : setBCCEmailErr('Please enter valid BCC Email');
            });
        } else setBCCEmailErr('');

        return flag;
    };

    const validateEmail = (value) => {
        value = value.trim();
        if (validator.isEmail(value)) {
            return true;
        } else return false;
    };

    const handleCreateAndPublished = () => {
        (!props.enableLoader) && props.setShowLoading(true);
        if (selectedUsers.get().length == 0) {
            (!props.enableLoader) && props.setShowLoading(false);
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants',
            });
        } else {
            const setUserTags = selectedTags.attach(Downgraded).get();
            const setUserTagsList =
                setUserTags.length > 0
                    ? setUserTags.map((tag) => tag.tagID).join(',')
                    : '';

            let requestObj = {
                participants: [],
                userTags: setUserTagsList,
            };
            let users = selectedUsers.attach(Downgraded).get();
            users.forEach((item) => {
                requestObj.participants.push({
                    eventUsersID: 0,
                    eventID: eventInfo.attach(Downgraded).get().eventID,
                    userID: item,
                    roleID: parseInt(userRole.get() ? userRole.get() : 0),
                    createdBy: userInfo.attach(Downgraded).get().userID,
                });
            });

            ApiHelper.post(APIURLConstants.POST_EVENT_PARTICIPANTS, requestObj)
                .then((res) => {
                    if (res.data > 0) {
                        // props.setSnackBarProps({
                        //     ...props.snackBarProps,
                        //     openSnack: true,
                        //     variant: 'success',
                        //     message: 'Participants added successfully',
                        // });
                        (!props.enableLoader) && props.setShowLoading(false);
                        handlePublished(
                            requestObj,
                            eventInfo.attach(Downgraded).get().eventID,
                            userInfo.attach(Downgraded).get().userID
                        );
                        // welcomeEmail(users.toString(),eventInfo.attach(Downgraded).get().eventID,userInfo.attach(Downgraded).get().userID)
                        props.handleClose();
                        props.getParticipants();
                        props.getAllParticipants();
                    }
                })
                .catch((error) => {
                    (!props.enableLoader) && props.setShowLoading(false);
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Error while adding participant';
                    }
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                    // props.handleClose();
                    // props.getParticipants();
                });
            //props.handleClose();
        }
    };

    const handlePublished = (array, eventID, modifiedBy) => {
        let obj = {};
        let publishedArray = [];
        let selectedUsers = [];

        if (array.participants && array.participants.length > 0) {
            array.participants.map((row) => {
                let newObj = {};
                newObj = {
                    userID: row.userID,
                    connectionID: row.userID,
                    isPublished: true,
                    isSchedulePublished: false,
                };
                publishedArray.push(newObj);
            });
        }
        publishedArray &&
            publishedArray.map((user) => {
                if (user.isPublished === true) {
                    selectedUsers.push(user.userID);
                }
            });

        obj = {
            eventID: eventID,
            modifiedBy: modifiedBy,
            UserWiseEventPublishSetting: publishedArray,
            IsBulk: true,
            Ids: selectedUsers.join(','),
        };
        console.log(obj);

        if (obj && obj !== {}) {
            // setLoading(true);
            ApiHelper.post(APIURLConstants.PARTICIPANT_EVENT_PUBLISHED, obj)
                .then((res) => {
                    if (res.data) {
                        // setLoading(false);
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message:
                                'Participant added and  published successfully',
                        });
                        if (eventData.get().readonlyOrHide === 0) {
                            saveAppNotification(selectedUsers);
                        }
                        // setSearch('');
                        // rowsData.set(null);
                        // columnsData.set(null);
                        // filterRowsData.set(null);
                        // props.getAllData();
                        // disableButton.set(false);
                    }
                    // disableButton.set(false);
                })
                .catch((err) => {
                    if (err) {
                        // setLoading(false);
                        console.log('err : ', err);
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Error in event published',
                        });
                        // disableButton.set(false);
                    }
                });
        }
    };
    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            maxWidth={'sm'}
            // title={'Export Itinerary'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
            dialogContentClasses={{ root: classes.dialogContentRoot }}
        />
    );
};
export default UserListDialog;
